import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_LEADS_ENVIADOS, CREATE_LEAD, UPDATE_LEAD, SEND_LEAD } from "./actionTypes"
import { getLeadsSuccess, getLeadsFail, createLeadSuccess, createLeadFail, updateLeadSuccess, updateLeadFail, sendLeadSuccess, sendLeadFail, clearSendLeadResult } from "./actions"

//Include Both Helper File with needed methods
import { getLeadsEnviados, createLead, updateLead, sendLead } from "helpers/blopsleads_helper"


// function* fetchLeadsPendentes() {
//   try {
//     const response = yield call(getLEADPendentes)
//     yield put(getLeadsSuccess(response))
//   } catch (error) {
//     yield put(getLeadsFail(error))
//   }
// }


// --- helpers ---
  const guidRe = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
  const isGuid = s => typeof s === "string" && guidRe.test(s)
  const extractFromObj = (o) => {
    if (!o || typeof o !== "object") return null
      const v = o.pkLeadJudicial ?? o.pkLeadsJudicial ?? o.pkLead ?? o.id
      return isGuid(v) ? v : null
    }
const extractPkFromResponse = (res) => {
    const itens = Array.isArray(res) ? res : (res?.itens || [])
      if (!itens.length) return null
      const first = itens[0] || {}
      const ret = first?.retorno ?? first?.Retorno ?? first
      let pk = extractFromObj(first)
      if (pk) return pk
      if (typeof ret === "string" && ret.trim()) {
        const s = ret.trim()
          try {
            const p = JSON.parse(s)
              if (Array.isArray(p) && p.length) pk = extractFromObj(p[0])
              else if (p && typeof p === "object") pk = extractFromObj(p)
            } catch (_) {
            const m = s.match(guidRe); if (m) pk = m[0]
            }
        return pk || null
        }
    if (Array.isArray(ret) && ret.length) return extractFromObj(ret[0])
      if (ret && typeof ret === "object") return extractFromObj(ret)
      return null
    }

function* fetchLeadsEnviados({ payload: leads }) {
  try {
    const response = yield call(getLeadsEnviados, leads);
    yield put(getLeadsSuccess(response))
  } catch (error) {
    yield put(getLeadsFail(error))
  }
}

function* onCreateLead({ payload: data }) {
  try {
    const response = yield call(createLead, data)

    yield put(createLeadSuccess(response))
    return response;
  } catch (error) {
    yield put(createLeadFail(error))
  }
}

function* onUpdateLead({ payload: data }) {
  try {
    const response = yield call(updateLead, data)

    yield put(updateLeadSuccess(response))
  } catch (error) {
    yield put(updateLeadFail(error))
  }
}

function* onSendLead({ payload: data }) {
  try {
    yield put(clearSendLeadResult());
    const response = yield call(sendLead, data)
    const pk = extractPkFromResponse(response)
    yield put(sendLeadSuccess(response))
    // sucesso -> marca como Enviado
    if (pk && data?.Id) {
        yield put(updateLead({
            Id: data.Id,
            Status: "Enviado",
            DataEnvio: new Date().toISOString(),
            PkLeadJudicial: pk,
          }))
      }
  } catch (error) {
    // Normaliza payload de erro para o formato esperado pela UI
    const failPayload = {
        destino: (data?.Destino || "pottencial"),
        total: 1,
        sucesso: 0,
        falha: 1,
        itens: [
          {
            id: data?.Id,
            ok: false,
            error:
            error?.response?.data?.message ||
              error?.message ||
             "Falha ao enviar lead",
          },
      ],

    }
    yield put(sendLeadFail(failPayload))
  }
}

function* LeadSaga() {
  yield takeEvery(GET_LEADS_ENVIADOS, fetchLeadsEnviados)
  yield takeEvery(CREATE_LEAD, onCreateLead)
  yield takeEvery(UPDATE_LEAD, onUpdateLead)
  yield takeEvery(SEND_LEAD, onSendLead)
}

export default LeadSaga
